import type * as React from "react";
import { Box, Typography } from "@mui/material";
import { COLORS } from "components/v3/Theme/colors";
import AccountLockIconDarkGray2 from "assets/icons/account-management-lock-dark-gray-2.svg";

const TITLE = "Your information is safe with us";
const DESCRIPTION =
  "Genomic Life uses SSL encryption to protect your information.";

const AccountSecurityCallout: React.FC = () => {
  return (
    <Box
      sx={{
        alignItems: "center",
        backgroundColor: COLORS.LIGHT_GRAY,
        borderRadius: "12px",
        boxSizing: "border-box",
        display: "flex",
        gap: 2,
        maxWidth: "100%",
        minWidth: 0,
        padding: 2.5,
        width: "100%"
      }}
    >
      <Box
        component="img"
        src={AccountLockIconDarkGray2}
        alt=""
        sx={{
          flexShrink: 0,
          height: 56,
          width: 56,
          objectFit: "contain"
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: "1 1 auto",
          gap: 0.75,
          minWidth: 0
        }}
      >
        <Typography
          variant="body_strong_black"
          sx={{ color: COLORS.DARK_GRAY_2, fontSize: "1rem", fontWeight: 700 }}
        >
          {TITLE}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: COLORS.DARK_GRAY_2, lineHeight: 1.5 }}
        >
          {DESCRIPTION}
        </Typography>
      </Box>
    </Box>
  );
};

export default AccountSecurityCallout;
